import Box from '@material-ui/core/Box'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Typography from '@material-ui/core/Typography'
import Skeleton from '@material-ui/lab/Skeleton'
import React, { useContext } from 'react'

import colorContext from '../../../../Context/colorContext'
import theme from '../../../../services/theme-service'

export default function SkeletonHighlight(): JSX.Element {
  const { colors } = useContext(colorContext)
  const useStyles = makeStyles(() => ({
    main: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: colors.colorBackground,
      alignItems: 'center',
      padding: '80px 5px 108px',
    },
    textTitle: {
      position: 'relative',
      textTransform: 'uppercase',
      fontFamily: 'Roboto',
      padding: '10px 0px 0px 3px',
      marginBottom: 50,
      fontWeight: 700,
      color: colors.textBody,
      left: 8,
      fontSize: theme.typography.pxToRem(36),
      '&::after': {
        content: '""',
        display: 'block',
        width: 4,
        height: 30,
        backgroundColor: colors.accentColor,
        position: 'absolute',
        bottom: 11,
        marginLeft: -14,
        left: 5,
      },
      [theme.breakpoints.down('xs')]: {
        fontSize: theme.typography.pxToRem(28),
        '&::after': {
          bottom: 4,
        },
      },
    },
    box: {
      margin: '40px 0px',
      width: '100%',
      maxWidth: 420,
      height: 215,
      [theme.breakpoints.down('sm')]: {
        maxWidth: 232,
        height: 'auto',
        margin: '0px',
      },
      [theme.breakpoints.down('xs')]: {
        width: '100%',
        display: 'flex',
        maxWidth: 'none',
        margin: '0px 20px 16px 20px',
      },
    },
    boxTitle: {
      display: 'flex',
      flexDirection: 'column',
      [theme.breakpoints.down('sm')]: {
        alignItems: 'center',
      },
    },
  }))
  const classes = useStyles()
  return (
    <Box className={classes.main}>
      <Box display="flex" maxWidth="1320px" width="100%" flexDirection="column">
        <Box className={classes.boxTitle}>
          <Typography className={classes.textTitle} variant="h5" component="h2">
            PROGRAMAS E AÇÕES
          </Typography>
        </Box>
        <Box display="flex" justifyContent="space-between" flexWrap="wrap">
          {Array.from({ length: 3 }).map((_, index) => (
            <Box className={classes.box} key={index}>
              <Skeleton variant="rect" width="100%" height="265px" />
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  )
}
